<template>
  <v-dialog
    :value="value"
    @input="$emit('input', $event)"
    persistent
    max-width="80%"
    scrollable
  >
    <v-card class="mx-auto pa-6">
      <base-material-card
        color="yellow"
        icon="mdi-clipboard-text"
        title="ปรับปรุงข้อมูลบุคลากร"
        class="px-5 py-3 text_google"
      />

      <v-card-text>
        <v-form ref="form" lazy-validation>
          <v-row no-gutters>
            <!-- ใบอนุญาตประกอบวิชาชีพครู -->
            <v-col
              cols="12"
              v-if="personnelData.position_name === 'พนักงานบริหารทั่วไป (ครู)'"
            >
              <div class="form-section-title">ใบอนุญาตประกอบวิชาชีพครู</div>
            </v-col>

            <LicenseSection
              v-if="personnelData.position_name === 'พนักงานบริหารทั่วไป (ครู)'"
              v-model="localData"
              license-type="teach"
              @delete="$emit('delete-license', 'teach')"
              @view="$emit('view-pdf', 'teach')"
              @file-change="handleTeachFileChange"
            />

            <!-- ใบอนุญาตผู้บริหาร -->
            <v-col
              cols="12"
              class="mt-4"
              v-if="personnelData.position_name === 'พนักงานบริหารทั่วไป (ครู)'"
            >
              <div class="form-section-title">
                ใบอนุญาตประกอบวิชาชีพผู้บริหารสถานศึกษา
              </div>
            </v-col>

            <LicenseSection
              v-if="personnelData.position_name === 'พนักงานบริหารทั่วไป (ครู)'"
              v-model="localData"
              license-type="director"
              @delete="$emit('delete-license', 'director')"
              @view="$emit('view-pdf', 'director')"
              @file-change="handleDirectorFileChange"
            />

            <!-- ... rest of the form ... -->

            <v-col cols="12">
              <v-divider class="my-4" />
            </v-col>

            <!-- ✅ เพิ่ม @file-change event -->
            <ContractSection
              v-model="localData"
              @delete="$emit('delete-license', 'contract')"
              @view="$emit('view-pdf', 'contract')"
              @file-change="handleContractFileChange"
            />

            <!-- ... rest of the form ... -->
          </v-row>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn fab outlined rounded @click="$emit('input', false)">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-btn outlined color="success" rounded @click="handleSubmit">
          <v-icon left>mdi-content-save</v-icon>
          บันทึก
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LicenseSection from "../components/LicenseSection.vue";
import SalaryBranchSection from "../components/SalaryBranchSection.vue";
import ContractSection from "../components/ContractSection.vue";
import EducationSection from "../components/EducationSection.vue";

export default {
  name: "EditPersonnelDialog",

  components: {
    LicenseSection,
    SalaryBranchSection,
    ContractSection,
    EducationSection
  },

  props: {
    value: {
      type: Boolean,
      default: false
    },
    personnelData: {
      type: Object,
      default: () => ({})
    },
    branches: {
      type: Array,
      default: () => []
    },
    educationTypes: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      // ✅ เพิ่มตัวแปรเก็บไฟล์
      uploadFiles: {
        contract: null,
        teach: null,
        director: null
      }
    };
  },

  computed: {
    localData: {
      get() {
        return this.personnelData;
      },
      set(value) {
        this.$emit("update:personnelData", value);
      }
    }
  },

  methods: {
    // ✅ เพิ่ม methods สำหรับจัดการไฟล์
    handleContractFileChange(file) {
      this.uploadFiles.contract = file;
    },

    handleTeachFileChange(file) {
      this.uploadFiles.teach = file;
    },

    handleDirectorFileChange(file) {
      this.uploadFiles.director = file;
    },

    handleSubmit() {
      if (this.$refs.form.validate()) {
        // ✅ ส่งไฟล์ไปด้วย
        this.$emit("submit", this.uploadFiles);
      }
    }
  }
};
</script>
